import createAPI from '../axios'

const workStatisticSkillsTraining = {
    statisticsRule: {
        queryList: config => createAPI('/workStatisticSkillsTraining/statisticsRule/queryList', 'post', config),
        save: config => createAPI('/workStatisticSkillsTraining/statisticsRule/save', 'post', config),
    },
    statisticalReport: {
        queryList: config => createAPI('/workStatisticSkillsTraining/statisticalReport/queryList', 'post', config),
        initCombo: config => createAPI('/workStatisticSkillsTraining/statisticalReport/initCombo', 'post', config),
    },
    log: {
        queryList: config => createAPI('/workStatisticSkillsTraining/log/queryList', 'post', config),
        initCombo: config => createAPI('/workStatisticSkillsTraining/log/initCombo', 'post', config),
        saveTeachingLog: config => createAPI('/workStatisticSkillsTraining/log/saveTeachingLog', 'post', config),
        queryTeachingLogList: config => createAPI('/workStatisticSkillsTraining/log/queryTeachingLogList', 'post', config),
        del: config => createAPI('/workStatisticSkillsTraining/log/del', 'post', config),
    },
    classHourStatistics: {
        queryList: config => createAPI('/workStatisticSkillsTraining/classHourStatistics/queryList', 'post', config),
        initCombo: config => createAPI('/workStatisticSkillsTraining/classHourStatistics/initCombo', 'post', config),
    }
};

export default workStatisticSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/workStatisticSkillsTraining.js